module.exports = __webpack_public_path__ + "static/media/img-df7a67c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/up-logo.png
// module id = 5304
// module chunks = 39